import { Link } from 'react-router-dom';

export default function DiaDasCriancasPage() {
  const programs = [
    {
      id: 1,
      title: 'Programa de Reconhecimento',
      description: 'Valorizamos e reconhecemos o desempenho excepcional de nossos colaboradores através de premiações, bonificações e reconhecimento público.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20employee%20recognition%20award%20ceremony%20with%20team%20celebrating%20achievement%2C%20modern%20office%20environment%20with%20blue%20corporate%20theme%2C%20business%20success%20celebration%20with%20trophy%20and%20certificate%20presentation%2C%20professional%20colleagues%20applauding%20winner%2C%20bright%20motivational%20atmosphere&width=800&height=600&seq=prog-incentivo-1&orientation=landscape'
    },
    {
      id: 2,
      title: 'Desenvolvimento Profissional',
      description: 'Investimos no crescimento contínuo através de treinamentos, workshops, cursos e programas de capacitação para desenvolver habilidades e competências.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20professional%20training%20workshop%20with%20employees%20learning%20new%20skills%2C%20modern%20conference%20room%20with%20blue%20theme%2C%20business%20education%20seminar%20with%20instructor%20and%20participants%2C%20professional%20development%20session%20with%20laptops%20and%20presentations%2C%20collaborative%20learning%20environment&width=800&height=600&seq=prog-incentivo-2&orientation=landscape'
    },
    {
      id: 3,
      title: 'Qualidade de Vida',
      description: 'Promovemos o bem-estar físico e mental com programas de saúde, ginástica laboral, apoio psicológico e ações de equilíbrio entre vida pessoal e profissional.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20wellness%20program%20with%20employees%20doing%20yoga%20and%20stretching%20exercises%2C%20modern%20office%20gym%20with%20blue%20accents%2C%20workplace%20health%20and%20fitness%20activities%2C%20professional%20team%20participating%20in%20wellness%20session%2C%20energetic%20healthy%20lifestyle%20atmosphere&width=800&height=600&seq=prog-incentivo-3&orientation=landscape'
    },
    {
      id: 4,
      title: 'Benefícios Corporativos',
      description: 'Oferecemos pacote completo de benefícios incluindo plano de saúde, vale-alimentação, vale-transporte, seguro de vida e parcerias com estabelecimentos.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20benefits%20package%20presentation%20with%20HR%20professional%20explaining%20employee%20perks%2C%20modern%20office%20meeting%20room%20with%20blue%20corporate%20colors%2C%20business%20benefits%20documentation%20and%20cards%20display%2C%20professional%20consultation%20about%20company%20advantages%2C%20welcoming%20supportive%20atmosphere&width=800&height=600&seq=prog-incentivo-4&orientation=landscape'
    },
    {
      id: 5,
      title: 'Programa de Metas',
      description: 'Sistema de metas claras e alcançáveis com recompensas por desempenho, incentivando a produtividade e o alcance de objetivos individuais e coletivos.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20goal%20achievement%20celebration%20with%20team%20reviewing%20performance%20metrics%20on%20digital%20dashboard%2C%20modern%20office%20with%20blue%20theme%2C%20business%20success%20tracking%20with%20charts%20and%20graphs%2C%20professional%20colleagues%20celebrating%20targets%20reached%2C%20motivational%20achievement%20atmosphere&width=800&height=600&seq=prog-incentivo-5&orientation=landscape'
    },
    {
      id: 6,
      title: 'Integração e Eventos',
      description: 'Realizamos eventos corporativos, confraternizações, celebrações de datas especiais e atividades de team building para fortalecer o espírito de equipe.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20team%20building%20event%20with%20employees%20participating%20in%20fun%20group%20activities%2C%20modern%20outdoor%20company%20gathering%20with%20blue%20branded%20materials%2C%20business%20team%20integration%20celebration%20with%20games%20and%20interaction%2C%20professional%20colleagues%20bonding%20together%2C%20joyful%20energetic%20atmosphere&width=800&height=600&seq=prog-incentivo-6&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Hero Section */}
      <section 
        className="relative min-h-[50vh] flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.85), rgba(37, 99, 235, 0.85)), url('https://readdy.ai/api/search-image?query=modern%20corporate%20office%20environment%20professional%20business%20team%20collaboration%20workspace%20with%20blue%20color%20scheme%20elegant%20lighting%20motivational%20atmosphere%20showcasing%20employee%20development%20programs%20and%20company%20culture&width=1920&height=800&seq=hero-prog&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/20 via-blue-700/10 to-blue-900/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 py-20 text-center w-full">
          <span className="inline-block px-6 py-3 bg-white/20 backdrop-blur-sm text-white text-sm font-semibold rounded-full mb-6">
            Pessoas & Cultura
          </span>
          <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Sustentare Programas de Incentivos
          </h1>
          <p className="text-xl lg:text-2xl text-white/95 max-w-3xl mx-auto leading-relaxed">
            Investimos no desenvolvimento e bem-estar dos nossos colaboradores através de programas estruturados de incentivo e reconhecimento
          </p>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center gap-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-blue-600 transition-colors">
              Início
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-medium">Programas de Incentivos</span>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            Nosso Compromisso com Você
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            Na Sustentare, acreditamos que o sucesso da empresa está diretamente ligado ao desenvolvimento 
            e satisfação de nossos colaboradores. Por isso, criamos programas estruturados que valorizam, 
            reconhecem e incentivam o crescimento profissional e pessoal de cada membro da nossa equipe.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Valorização</h3>
              <p className="text-gray-600">Reconhecemos e valorizamos cada contribuição</p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Crescimento</h3>
              <p className="text-gray-600">Investimos no desenvolvimento contínuo</p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Bem-estar</h3>
              <p className="text-gray-600">Cuidamos da saúde e qualidade de vida</p>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Grid */}
      <section className="py-16 bg-gradient-to-b from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Nossos Programas
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Conheça os programas que fazem da Sustentare um excelente lugar para trabalhar e crescer profissionalmente
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {programs.map((program) => (
              <div 
                key={program.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group hover:-translate-y-2"
              >
                <div className="relative h-64 w-full overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-t from-blue-900/80 via-blue-600/40 to-transparent z-10"></div>
                  <img 
                    src={program.image}
                    alt={program.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                    {program.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {program.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Resultados e Impacto
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Nossos programas de incentivos geram resultados concretos para colaboradores e empresa
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-gradient-to-br from-blue-600 to-blue-500 rounded-xl p-8 text-white text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-5xl font-bold mb-2">95%</div>
              <div className="text-blue-100 text-lg">Satisfação dos Colaboradores</div>
            </div>
            <div className="bg-gradient-to-br from-blue-600 to-blue-500 rounded-xl p-8 text-white text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-5xl font-bold mb-2">80%</div>
              <div className="text-blue-100 text-lg">Retenção de Talentos</div>
            </div>
            <div className="bg-gradient-to-br from-blue-600 to-blue-500 rounded-xl p-8 text-white text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-5xl font-bold mb-2">+40%</div>
              <div className="text-blue-100 text-lg">Aumento de Produtividade</div>
            </div>
            <div className="bg-gradient-to-br from-blue-600 to-blue-500 rounded-xl p-8 text-white text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-5xl font-bold mb-2">100+</div>
              <div className="text-blue-100 text-lg">Colaboradores Beneficiados</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-blue-900 to-blue-600">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Faça Parte da Nossa Equipe
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Venha trabalhar em uma empresa que valoriza e investe em seus colaboradores. 
            Conheça nossas oportunidades de carreira.
          </p>
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/contato')}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Entre em Contato
          </button>
        </div>
      </section>
    </div>
  );
}
